module.exports = __webpack_public_path__ + "assets/img/4e82-ls.svg";